export const ADMIN = 'ADMIN'
export const APP_ADMIN = 'APP_ADMIN'
export const APP_WHITEBOARD = 'APP_WHITEBOARD'
export const APP_BOX_MEMBERSHIPS = 'APP_BOX_MEMBERSHIPS'
